export default {"src":"https://fishbrain.com/_next/static/media/thirdPlace.1a817f9a.svg","height":22,"width":22,"blurWidth":0,"blurHeight":0};